'use client'
import type { ReactNode } from 'react'
import { motion } from 'framer-motion'

import Icon, { IconName } from './Icon'

interface SectionHeaderProps {
  subtitle?: string
  heading: string
  highlighted?: string
  description?: ReactNode
  marginBottom?: string
  delay?: number
  icon?: IconName
  iconColor?: string
  highlightClassName?: string
}

export default function SectionHeader({
  subtitle,
  heading,
  highlighted,
  description,
  marginBottom = 'mb-16',
  delay = 0.6,
  icon,
  iconColor = 'text-[var(--brand-400)]',
  highlightClassName = 'gradient-text',
}: SectionHeaderProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay }}
      className={`text-center max-w-3xl mx-auto ${marginBottom}`}
    >
      {subtitle && (
        <span className="text-sm font-medium text-[var(--brand-400)] tracking-wide uppercase block mb-3">{subtitle}</span>
      )}
      <div className="flex items-center justify-center gap-3">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">
          {heading}{' '}
          {highlighted && <span className={highlightClassName}>{highlighted}</span>}
        </h2>
        {icon && <Icon name={icon} className={`w-10 h-10 drop-shadow-lg ${iconColor}`} strokeWidth={1.5} />}
      </div>
      {description && (
        <p className="mt-4 text-[#94a3b8] text-lg leading-relaxed">{description}</p>
      )}
    </motion.div>
  )
}
